export default __webpack_public_path__ + "static/media/shape-30.f48bfca0.png";